export const DISCIPLE_AGE_CHILDREN = "DISCIPLES_AGE_CHILDREN"
export const DISCIPLE_AGE_ADULTS = "DISCIPLES_AGE_ADULTS"

export const discipleAgeOptions = {
  [DISCIPLE_AGE_CHILDREN]: "для детей",
  [DISCIPLE_AGE_ADULTS]: "для взрослых",
}
